import { CLIENT_ID } from "../constants";

export function assign<T extends object, K extends keyof T>(
    obj: T, key: K, val: T[K]
) {
    obj[key] = val; // okay
}

export const redirectToUrl = (base:string,auth:string,company:string) => {
    window.location.href = base + "?code=" + auth + "&com=" + company
}

export const redirectToLogin = () => {
    window.location.href = "/sso?client=" + CLIENT_ID
}

// use to check if contains role
export const checkRoles = (list:string[], roles:string[]) : boolean => {
    for (const item of list) {
        for (const role of roles) {
            if (role === item) {
                return true
            }
        }
    }
    return false
}